<template>
  <v-expansion-panels class="w-form" v-model="openedPanel" accordion>
    <v-expansion-panel>
      <v-expansion-panel-header class="tit-lev1">
         <v-spacer />

         <div
          :class="['sign-status', signStatusClass]"
        >
          {{ signStatusText }}
        </div>


          <v-btn
            small
            depressed
            color="primary"
            class="mr-2"
            :disabled="!canSign"
            @click.native.stop="btnSign"
          >
            <span class="caption">
              {{t('Sign')}}
            </span>
          </v-btn>

          <v-btn
            small
            depressed
            color="primary"
            max-width="80px"
            @click.native.stop="toggleLang"
          >
            {{ language }}
          </v-btn>
      </v-expansion-panel-header>
      <v-expansion-panel-content  class="search-panel">
        <v-expansion-panels v-model="cOpenedPanel" accordion>
            <!-- Date -->
            <v-expansion-panel>
              <v-expansion-panel-header>                                
                {{t('Date')}}: {{ searchDate }}
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <div class="xy-center">
                  <div class="mr-2">
                    <v-menu
                      ref="searchDateRef"
                      :close-on-content-click="false"
                      :return-value.sync="searchDate"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="searchDate"
                          :label="t('Date')"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details
                        />
                      </template>

                      <v-date-picker v-model="searchDate" no-title scrollable>
                        <v-spacer />

                        <v-btn
                          text
                          @click="$refs.searchDateRef.isActive = false"
                        >
                        {{t('Cancel')}}
                        </v-btn>

                        <v-btn
                          text
                          @click="$refs.searchDateRef.save(searchDate)"
                        >
                        {{t('OK')}}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Dept -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ t('Dept') }}: {{ showDeptName || 'Pre-Painting' }}
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-select
                  v-model="dept"
                  :items="listDept"
                  item-value="code"
                  item-text="name"
                  :label="t('SelectDept')"
                  @change="deptChanged"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Group -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{t('Group')}}: {{ showGroup }}
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-select
                  v-model="group"
                  :items="listGroup"
                  item-value="code"
                  item-text="name"
                  :label="t('SelectGroup')"
                   @change="groupChanged"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Team -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{t('Team')}}: {{ showTeam }}
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-select
                  v-model="team"
                  :items="listTeam"
                  item-value="code"
                  item-text="name"
                  :label="t('SelectTeam')"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-row no-gutters class="px-2 align-center" style="height: 50px;">
              <v-col cols="12">
                <v-radio-group
                  v-model="searchType"
                  row
                  hide-details
                  class="font-weight-bold ml-5"
                >
                  <v-radio value="P">
                    <template v-slot:label>
                      <span class="blue--text font-weight-bold">
                        {{ t('Plan') }}
                      </span>
                    </template>
                  </v-radio>

                  <v-radio value="A">
                    <template v-slot:label>
                      <span class="red--text font-weight-bold">
                        {{ t('Actual') }}
                      </span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row> 
            </v-expansion-panels>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- End of search condition area -->
    <v-divider></v-divider>
    <!-- List information -->
    <!-- Start search result area -->
    <v-expansion-panel>
      <v-expansion-panel-header class="tit-lev1">
        {{t('Result')}}:
        {{ listSize === 0 ? t('0') : listSize }}
        <v-spacer />
        <v-btn  v-if="writeYn" small depressed color="primary" max-width="60px" @click.native.stop="btnAdd"> <span class="caption ">{{t('Add')}}</span> </v-btn>
      </v-expansion-panel-header>
      <v-expansion-panel-content  class="result-panel">
        <v-text-field
          class="mt-2"
          :label="t('Filter')"
          prepend-inner-icon="mdi-magnify"
          outlined
          clearable
          clear-icon="mdi-close-circle-outline"
          v-model="txtFilter"
          hide-details
          small
        />
        <v-list nav dense>
          <v-list-item-group>
            <v-divider />
                <v-virtual-scroll
                  bench="60"
                  :items="filteredItems"
                  height="calc(100vh - 270px)"
                  item-height="260"
                >
                  <template v-slot:default="{ index, item }">
                    <v-list-item ::key="item.empNo + '-' + item.seq">

                      <v-list-item-title
                        @click="listItemClick(item)"
                        style="white-space: normal;"
                      >
                        <div style="display:flex; justify-content:flex-end;">

                          <v-btn                        
                            
                            
                            small
                            color="success"
                            class="mr-2 mt-2"
                            @click.stop="btnAdd(item)"
                          >
                          {{ t('Add') }}
                          </v-btn>
                          
                          <v-btn

                            
                            small
                            color="primary"
                            class="mr-2 mt-2"
                            @click.stop="btnDelete(item)"
                          >
                          {{t('Delete')}}
                          </v-btn>
                        </div>
                        
                        <tr>
                          <td style="width: 120px">
                            <v-chip
                              :style="{
                                backgroundColor: searchType === 'P'
                                  ? 'rgb(186,208,235)'
                                  : 'rgb(247,195,184)',
                                color: '#000'
                              }"
                              small
                            >
                              {{ item.empNo }}
                            </v-chip>
                          </td>

                          <td>
                            <strong>{{ item.empNm }}</strong>
                          </td>
                        </tr>


                        <tr>
                          <td><strong>{{t('Absent')}} :</strong></td>
                          <td>{{ item.gunte }}</td>
                        </tr>

                        <tr> 
                          <strong>{{ t('ShipNo') }} :</strong>
                          <td>{{ item.shipNo }}</td>
                        </tr>

                        <tr>
                          <td><strong>Block :</strong></td>
                          <td>{{ item.block }}</td>
                        </tr>

                        <tr>
                          <td><strong>{{t('WorkHourType')}} :</strong></td>
                          <td>{{ item.sunNm }}</td>
                        </tr>

                        <tr>
                          <td><strong>{{t('Working')}} :</strong></td>
                          <td>{{ item.wkActNm }}</td>
                        </tr>

                        <tr>
                          <td><strong>{{t('Place')}} :</strong></td>
                          <td>{{ item.wkPlaceNm }}</td>
                        </tr>

                        <tr>
                          <td><strong>{{t('Begin')}} :</strong></td>
                          <td>{{ item.ftime }}</td>
                        </tr>

                        <tr>
                          <td><strong>{{t('End')}} :</strong></td>
                          <td>{{ item.ttime }}</td>
                        </tr>

                        <tr>
                          <td><strong>{{t('Total')}} :</strong></td>
                          <td>{{ item.total }}</td>
                        </tr>

                        <tr>
                          <td><strong>{{t('Seq')}} :</strong></td>
                          <td>{{ item.seq }}</td>
                        </tr>

                      </v-list-item-title>

                    </v-list-item>

                    <v-divider :key="item.shipno + index" />
                  </template>
                </v-virtual-scroll>

              </v-list-item-group>

        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- End of search result area -->
<!-- Start detailed dialog -->
    <v-dialog fullscreen persistent v-model="showDetail">
      <v-card>

          <v-toolbar
            height="55px"
            :style="{
              backgroundColor:
                searchType === 'P'
                  ? 'rgb(186,208,235)'
                  : 'rgb(247,195,184)'
            }"
          >
          <v-chip
            dark
            small
            :color="searchType === 'P' ? 'blue darken-2' : 'deep-orange darken-2'"
          >
            {{ itemDetail.empNo }}
          </v-chip>

          <v-spacer />

          <v-btn icon>
            <v-icon @click="showDetail = false">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-sheet
          style="overflow-x: auto; overflow-y: auto"
          max-height="calc(100vh - 55px)"
        >

          <div class="pt-3 mr-3" style="display:flex;justify-content:end;">
            <v-btn
            small
            color="primary"
            class="mr-2"
            @click="btnSave"
            >
            {{t('Save')}}
            </v-btn>
          </div>

          <v-simple-table style="white-space: normal;">
            <template v-slot:default>
              <tbody>

                <!-- Employee -->
                <tr>
                  <td style="padding-left: 15px; padding-top: 6px; vertical-align: middle;">
                    <strong>{{ t('Employee') }}</strong>
                  </td>

                  <td style="padding-top: 6px; vertical-align: middle;">
                    {{ itemDetail.empNo }} / {{ itemDetail.empNm }}
                  </td>
                </tr>

                <!-- Gunte -->
                <tr>
                  <td><strong>{{t('Absent')}} </strong></td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.gunte"
                      :items="listGunte"
                      item-value="code"
                      item-text="name"
                      hide-details
                      dense
                    />
                  </td>
                </tr>

                <!-- Ship No -->
                <tr>
                  <td><strong>{{t('ShipName')}} :</strong></td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.shipNo"
                      :items="listShip"
                      item-value="code"
                      item-text="name"
                      hide-details
                      dense
                    />
                  </td>
                </tr>

                <!-- Sun -->
                <tr>
                  <td><strong> {{t('WorkHourType')}} </strong></td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.sun"
                      :items="listSun"
                      item-value="code"
                      item-text="name"
                      hide-details
                      :disabled="Number(itemDetail.seq) !== 0"
                      :title="Number(itemDetail.seq) !== 0 ? 'Cannot change after saved' : ''"
                      dense
                      @change="changeSun"
                    />
                  </td>
                </tr>

                <!-- Block -->
                <tr>
                  <td><strong>Block</strong></td>
                  <td>
                    <v-text-field
                      v-model="itemDetail.block"
                      hide-details
                      dense
                    />
                  </td>
                </tr>

                <!-- Work Act -->
                <tr>
                  <td><strong>{{ t('WorkAct') }}</strong></td>
                  <td>
                    <v-autocomplete
                    :key="itemDetail.sun + '-' + itemDetail.shipNo + '-' + showDetail"
                    v-model="itemDetail.workAct"
                    :items="listWorkAct"
                    item-value="code"
                    item-text="name"
                    hide-details
                    dense
                    />
                  </td>
                </tr>

                <!-- Place -->
                <tr>
                  <td><strong>{{t('Place')}}</strong></td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.wkPlace"
                      :items="listPlace"
                      item-value="code"
                      item-text="name"
                      hide-details
                      dense
                    />
                  </td>
                </tr>

                <!-- From -->
                <tr>
                  <td><strong>{{ t('From') }}</strong></td>
                  <td>
                    <v-text-field
                      v-model="itemDetail.ftime"
                      hide-details
                      dense
                    />
                  </td>
                </tr>

                <!-- To -->
                <tr>
                  <td><strong>{{ t('To') }}</strong></td>
                  <td>
                    <v-text-field
                      v-model="itemDetail.ttime"
                      hide-details
                      dense
                    />
                  </td>
                </tr>

                <!-- Total -->
                <tr>
                  <td><strong>{{ t('Total') }}</strong></td>
                  <td>{{ itemDetail.total }}</td>
                </tr>

              </tbody>
            </template>
          </v-simple-table>

        </v-sheet>
      </v-card>
    </v-dialog>
<!-- End detailed dialog -->
    <!-- Scroll To Top -->
    <v-btn small v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="primary" @click="toTop">
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </v-expansion-panels>
</template>

<script>
import { 
         getPurpose, 
         getPlace, 
         getShipNo, 
        //  getTugBoat, 
         getDept,
         getGroup,
         getTeam,
         getWorkActShip,
         getWorkActExShip,
         getWorkActIndirect,
         getGunte,
         insertPlan,
         updatePlan,
         deleteActual,   
         insertActual,
         deletePlan,
         searchPlanList,
         searchActualList,
         searchPlanList_SUB,
         searchActualList_SUB,
         getSignStatus,
         confirmSign 
       } from '@/api/view/pp/20/v20a7000.js'

import { DxScrollView } from 'devextreme-vue/scroll-view'
import { DxPopup } from 'devextreme-vue/popup'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import notify from 'devextreme/ui/notify' // message
import { getDateFormat, getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs'
import moment from 'moment'
import { fn_uni2vni, fn_vni2uni } from '@/api/view/pp/common/common.js'
import EventBus from '@/components/event-bus'

export default {
  name: 'v20a7000m',
  mixins: [baseview, BaseDataGrid],

  components: {
    DxPopup,
    ICardVertical,
    'i-card-top': iCardTop,
    DxDateBox,
    DxScrollView
    // AppButton,
  },
  props: {},
  data: () => ({
    openedPanel: 0,
    cOpenedPanel: -1,
    txtFilter: '',

    menuTitle: '', //this.$route.meta.title,
    useBtnList: ['btnRetrieve', 'btnAdd'], //,'btnAdd','btnSave', , 'btnDelete'
    selected: [0],
    fab: false,
    dark: false,

    //Language
    language: 'VI',

    //Date
    modal_from: '',
    modal_to: '',

    searchType: 'P',

    fday: '',
    tday: '',
    //Time select
    fhhmm: null,
    thhmm: null,
    modal_ftime: false,
    modal_ttime: false,

    listShip: [],
    listRShip: [],
    cboShipNo: '',

    cboTugBoat: '',
    cboTugBoatCopy: '',
    listTugBoat: [],

    searchDate: moment().format('YYYY-MM-DD'),

    dept: 'B1',
    group: '',
    team: '',

    listDept: [],
    listGroup: [],
    listTeam: [],

    listGunte: [],
    listSun: [
      { code: '1', name: 'Ship' },
      { code: '2', name: 'Except Ship' },
      { code: '3', name: 'Indirect' }
    ],

    // Work Act lists
    listWorkAct: [],
    listWorkActShip: [],
    listWorkActExShip: [],
    listWorkActIndirect: [],

    cboFjangso: '',
    cboTjangso: '',
    listPlace: [],
    listPurpose: [],
    listFuelOil: [
        {code: 'M', name: 'Ship moving'},
        {code: 'S', name: 'Support'},
      ],
    movDate: moment().format('YYYY-MM-DD'),
    fdate: moment().format('YYYY-MM-DD'),
    tdate: moment().format('YYYY-MM-DD'),
    gridMainList: [],
    listSize: 0,
    showDetail: false,
    oriItem: {},
    itemDetail: {
      gunte: '%', // default value for gunte
      sun: '0'
    },
    isNew: false,

    // ================= SIGN =================

    signStatus: 'N',

    grLeadCd:'',
    snMgrCd:'',

    //
    
    writeYn: 'N',
     rules: {
      onlyNumbers: value => /^\d+$/.test(value) || "Enter numbers only!"
    }
  }),

  created() {
    // console.log("created: "+this.$options.name + "_search");
    EventBus.$on(this.$options.name + '_search', () => {
      this.btnSearch()
    })
  },

  mounted() {
    // 
    this.itemDetail.gunte = ''; 

    //
    this.itemDetail.sun = '0';

    this.writeYn = this.$gUtil.getWriteYn()
    // console.log("writeYn: ", this.writeYn );
    this.btnCaption = false
    this.btnChief   = false
    this.setCombo()
  },

  beforeDestroy() {
    this.writeYn = this.$gUtil.getWriteYn()
    // console.log("beforeDestroy: "+this.$options.name + "_search");
    EventBus.$off(this.$options.name + '_search')
  },

  computed: {
    filteredItems: function() {
      return this.$gUtil.executeFilter(this.gridMainList, this.txtFilter)
    },
    tugBoat: function() {
      const items = this.listTugBoat.filter(item => item.code && item.code === this.cboTugBoat)
      return items.length > 0 ? items[0].name : 'ALL'
    },
    tugBoatCopy: function() {
      const items = this.listTugBoat.filter(item => item.code && item.code === this.cboTugBoatCopy)
      return items.length > 0 ? items[0].name : 'ALL'
    },
    // shipNo: function() {
    //     const items = this.listShip.filter(item => item.code && item.code === this.cboShipNo);
    //     return items.length > 0 ? items[0].name : "ALL";
    // },
    showGroup() {
        const item = this.listGroup.find(
          x => x.code === this.group
        )

      return item ? item.name : 'ALL'
    },
    showTeam() {
        const item = this.listTeam.find(
          x => x.code === this.team
        )

      return item ? item.name : 'ALL'
    },

    signStatusText() {

      switch (this.signStatus) {

        case 'N':
          return this.t('Status0')

        case '1':
          return this.t('Status1')

        case '2':
          return this.t('Status2')

        default:
          return ''

      }

      },

    signStatusClass() {
        switch (this.signStatus) {
          case "1":
            return "status-sign1"
          case "2":
            return "status-sign2"
          default:
            return "status-sign0"
        }
      },


    canSign(){

      const userId = this.$store.state.user.userId

      if(this.signStatus === 'N'){
        return userId === this.grLeadCd
      }

      if(this.signStatus === '1'){
        return userId === this.snMgrCd
      }


      return false
      },
    
     showDeptName() {
        const item = this.listDept.find(x => x.code === this.dept)
        return item ? item.name : ''
  },
    
  },

  methods: {

    getLangText() {

      return {

        Department: {
          EN: 'Department',
          VI: 'Phòng'
        },

        Date: {
          EN: 'Date',
          VI: 'Ngày'
        },

        Dept: {
          EN: 'Dept',
          VI: 'Phòng'
        },

        Group: {
          EN: 'Group',
          VI: 'Nhóm'
        },

        Team: {
          EN: 'Team',
          VI: 'Tổ'
        },

        Result: {
          EN: 'Result',
          VI: 'Kết quả'
        },

        WorkAct: {
          EN: 'Work Act',
          VI: 'Công việc'
        },

        Filter: {
          EN: 'Filter',
          VI: 'Lọc'
        },

        Add: {
          EN: 'Add',
          VI: 'Thêm'
        },

        Delete: {
          EN: 'Delete',
          VI: 'Xóa'
        },

        Save: {
          EN: 'Save',
          VI: 'Lưu'
        },

        Employee: {
          EN: 'Employee',
          VI: 'Nhân viên'
        },

        Absent: {
          EN: 'Absent',
          VI: 'Chuyên cần'
        },

        ShipNo: {
          EN: 'Ship No',
          VI: 'Tàu số'
        },

        Block: {
          EN: 'Block',
          VI: 'Block'
        },

        WorkHourType: {
          EN: 'Work hour Type',
          VI: 'Loại giờ công'
        },

        Working: {
          EN: 'Working',
          VI: 'Công việc'
        },

        Place: {
          EN: 'Place',
          VI: 'Nơi làm'
        },

        Begin: {
          EN: 'Begin',
          VI: 'Bắt đầu'
        },

        End: {
          EN: 'End',
          VI: 'Kết thúc'
        },

        Total: {
          EN: 'Total',
          VI: 'Tổng giờ'
        },

        Seq: {
          EN: 'Seq',
          VI: 'STT'
        },

        From:{
          EN:'From',
          VI:'Bắt đầu'
        },

        To:{
          EN:'To',
          VI:'Kết thúc'
        },

        Total:{
          EN:'Total',
          VI:'Tổng'
        },

        ShipName:{
          EN:'Ship Name',
          VI:'Tên tàu'
        },

        Plan:{
          EN:'PLAN',
          VI:'KẾ HOẠCH'
        },

        Actual:{
          EN:'ACTUAL',
          VI:'THỰC TẾ'
        },

        Sign:{
          EN:'Sign',
          VI:'Kí'
        },

        Status0:{
          EN:'○ Not signed',
          VI:'○ Chưa kí'
        },

        Status1:{
          EN:'◐ Group Leader signed',
          VI:'◐ Nhóm trưởng đã kí'
        },

        Status2:{
          EN:'● Sn. MGR signed',
          VI:'● Quản lý đã kí'
        },


      }

      },


      t(key){

      const lang = this.getLangText()

      return lang[key]?.[this.language] || key

      },


      toggleLang(){

      this.language =
        this.language === 'EN'
          ? 'VI'
          : 'EN'

      },

    getWorkActText(item) {
    return item.name.split(':').slice(1).join(':').trim()
  },

    async changeShipNo() {
      this.itemDetail.workAct = null
      await this.loadWorkAct()
    },

    async changeSun() {
      this.listWorkAct = []
      this.itemDetail.workAct = null 
      await this.loadWorkAct()
    },

    async loadWorkAct() {
      this.listWorkAct = []

      let result = null

      const params = {
        shipNo: this.itemDetail.shipNo,
        respCd: this.group
      }

      if (this.itemDetail.sun === '1') {
        result = await getWorkActShip(params)
      } else if (this.itemDetail.sun === '2') {
        result = await getWorkActExShip(params)
      } else if (this.itemDetail.sun === '3') {
        result = await getWorkActIndirect(params)
      }

      const list = result?.list || []

      this.listWorkAct = list.map(x => ({
        code: (x.code || '').trim(),
        name: x.name
      }))

      // 
      this.$nextTick(() => {
        const exists = this.listWorkAct.find(
          x => x.code === (this.itemDetail.workAct || '').trim()
        )

        if (!exists) {
          this.itemDetail.workAct = null
        }
      })
    },

    getWorkActName(item) {
      const code = (item.workAct || '').trim()

      return this.listWorkAct.find(x => x.code === code)?.name || ''
    },
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop() {
      this.$vuetify.goTo(0)
    },

    onlyNumber(event) {//@keypress="onlyNumber"
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    filterNumber() {//@input="filterNumber"
      this.numberValue = this.numberValue.replace(/\D/g, ""); // Chỉ giữ lại số
    }, 

    async btnSign(){

    const param = {

      date: this.searchDate.replace(/-/g,''),

      group: this.group,   

      type: this.searchType,

      status: this.signStatus

      }

      await confirmSign(param)

      await this.btnSearch()

    },
    async loadSignStatus(){

      const param = {
        date: this.searchDate.replace(/-/g, ''),
        group: this.group,
        type: this.searchType,
        userId: this.$store.state.user.userId
      }

      const result = await getSignStatus(param)

      if (result.list && result.list.length > 0) {
        const signInfo = result.list[0]

        this.signStatus = signInfo.status
        this.grLeadCd = signInfo.grLeadCd
        this.snMgrCd = signInfo.snMgrCd
        this.grLeadNm = signInfo.grLeadNm
        this.snMgrNm = signInfo.snMgrNm
      }


    },

    async  btnSearch() {
      
      this.gridMainList = []
      await this.doSearchMainList()

      
      
    },
    async doSearchMainList() {
      const params = {
        date: this.searchDate.replace(/-/g, ''),
        group: this.group,
        jo: this.team ? this.team.substring(0, 2) : '',
        gr: this.team ? this.team.slice(-1) : ''
      }

      let res

      if (this.searchType === 'P') {
        res = this.group && !this.group.startsWith('5')
          ? await searchPlanList_SUB(params)
          : await searchPlanList(params)
      } else {
        res = this.group && !this.group.startsWith('5')
          ? await searchActualList_SUB(params)
          : await searchActualList(params)
      }

      this.gridMainList = res.list || []
      this.listSize = this.gridMainList.length

      this.openedPanel = 1

      await this.loadSignStatus()

      },

    getStrFormat(date) {
      return getDateFormat(date)
    },

    async deptChanged() {
        this.group = ''
        this.team = ''
        this.listGroup = []
        this.listTeam = []
        this.listPlace = [] // Xóa danh sách nơi làm việc cũ

        // Nạp lại Group, Place và Team theo Dept mới chọn
        await this.loadGroup()
        await this.loadPlace()
        await this.loadTeam()
      },

    async loadPlace() {
          const result = await getPlace({
            dept: this.dept || 'B1' // Tránh null/undefined truyền lên SQL
          })
          this.listPlace = result.list || []
        },
    async setCombo() {
      // this.openLoading('Đang tìm')

      let params = { tugNo: '' }

      //getPurpose
      const purpose = async () => {
        await getPurpose(params).then(result => {
          this.listPurpose = result.list
          // result.list.forEach(item => {
          //   this.listPurpose.push({
          //     name: item.name,
          //     code: item.code
          //   })
          // })
        })
      }
      // getShipNo
      const ship = async () => {
        await getShipNo(params).then(result => {
          // console.log("####res.list", res.list);
          this.listShip = result.list
          // this.listRShip = JSON.parse(JSON.stringify(result.list));
          // this.listShip.splice(0, 0, { code: "%", name: "ALL" });
        })
      }

      // getTugBoat
      // const tugboat = async () => {
      //   await getTugBoat(params).then(result => {
      //     // console.log("####result.list", res.list);
      //     this.listTugBoat = result.list
      //     // this.listTugBoat.splice(0, 0, { code: "%", name: "ALL" });
      //   })
      // }

      // getDept
      let paramsDept = {
        userId: this.$store.state.user.userId
      }
      const loadDept = async () => {
        const result = await getDept({
          userId: this.$store.state.user.userId
        })
        this.listDept = result.list || []
        if (this.listDept.length > 0) {
          // Ưu tiên chọn B1 nếu có, không thì lấy Dept đầu tiên
          const hasB1 = this.listDept.find(x => x.code === 'B1')
          this.dept = hasB1 ? 'B1' : this.listDept[0].code
        }
      }
      

      // getGroup
      const loadGroup = async () => {
        const result = await getGroup({
          dept: this.dept
        })

        this.listGroup = result.list

        if (result.list.length > 0) {
          this.group = result.list[0].code
        }
      }

      // getTeam
      const loadTeam = async () => {
        const result = await getTeam({
          group: this.group
        })

        this.listTeam = result.list

        if (result.list.length > 0) {
          this.team = result.list[0].code
        }
      }
      // getGunte
      const gunte = async () => {
        try {
          const result = await getGunte({});
          if (result && result.list) {
            // Làm sạch và gán mới mảng
            this.listGunte = result.list.map(item => ({
              // Giữ nguyên ký tự '%' từ SQL đổ về, không lo bị dính chữ "null"
              code: item.code,
              name: item.name.trim()
            }));
          }
        } catch (error) {
          console.error("Lỗi nạp dữ liệu Gunte:", error);
        }
      }
      // const gunte = async () => {
      //   await getGunte({}).then(result => {
      //     result.list.forEach(item => {
      //       this.listGunte.push({
      //         code: item.code,
      //         name: item.name
      //       })
      //       //console.log('gunte:', this.listGunte)
      //     })
      //   })
      // }


      this.$qLoading.show()

      try {
        await Promise.all([
          ship(),
          // tugboat(),
          purpose(),
          loadDept(),
          gunte()
        ])

        await loadGroup()
        await loadPlace()
        await loadTeam()

      } catch (ex) {
        console.log(ex)
      } finally {
        this.$qLoading.hide()
      }
    },

    async deptChanged() {
        this.group = ''
        this.team = ''

        await this.loadGroup()
        await this.loadPlace()
        await this.loadTeam()
      },

      async groupChanged() {
        this.team = ''

        await this.loadTeam()
      },

      async loadGroup() {
        const result = await getGroup({
          dept: this.dept
        })

        this.listGroup = result.list

        if (result.list.length > 0) {
          this.group = result.list[0].code
        }
      },

      async loadTeam() {
        const result = await getTeam({
          group: this.group
        })

        this.listTeam = result.list

        if (result.list.length > 0) {
          this.team = result.list[0].code
        }
      },

    btnAdd(item) {
      this.itemDetail = {
        empNo: item.empNo,
        empNm: item.empNm,
        teamJo: item.teamJo,
        teamGr: item.teamGr,
        gunte: item.gunte,
        sun: item.sun,

        seq: 0,

        shipNo: '',
        workAct: '',
        wkPlace: '',
        ftime: '',
        ttime: '',
        block: '',
        total: ''
      }

      this.isNew = true
      this.showDetail = true
      },

    btnSave() {
      return this.searchType === 'P'
        ? this.savePlan()
        : this.saveActual()
    },

    async savePlan() {

      // only when not gunte, the other fields are required
      if (!this.itemDetail.gunte) {

      if (!this.itemDetail.shipNo) {
        this.vToastify('Ship No required', 'warn')
        return
      }

      if (!this.itemDetail.workAct) {
        this.vToastify('Working required', 'warn')
        return
      }

      if (!this.itemDetail.ftime) {
        this.vToastify('Begin required', 'warn')
        return
      }

      if (!this.itemDetail.ttime) {
        this.vToastify('End required', 'warn')
        return
      }

      }

      if (!this.group?.startsWith('5')) {
              this.itemDetail.teamJo = '00'
              this.itemDetail.teamGr = '0'
              
            }

      const param = {
        wkDate: this.movDate.replace(/-/g, ''),
        respCd: this.group,
        teamCd: this.itemDetail.teamJo|| '',
        ser: this.itemDetail.teamGr|| '',

        empNo: this.itemDetail.empNo,
        sun_s: (
          this.itemDetail.gunte == '%' ||
          this.itemDetail.gunte == '' ||
          this.itemDetail.gunte == ' ' ||
          this.itemDetail.gunte == null
        )
          ? this.itemDetail.sun
          : '0',

        seq: this.itemDetail.seq,
        gunte: (
          this.itemDetail.gunte == '%' ||
          this.itemDetail.gunte == '' ||
          this.itemDetail.gunte == ' ' ||
          this.itemDetail.gunte == null
        )
          ? ''
          : this.itemDetail.gunte|| '',
          
        shipNo: this.itemDetail.shipNo || '',
        workAct: this.itemDetail.workAct || '',
        wkPlace: this.itemDetail.wkPlace || '',
        fr_time: this.itemDetail.ftime || '',
        to_time: this.itemDetail.ttime || '',
        block: this.itemDetail.block || '',

        userId: this.$store.state.user.userId
      }
      console.log('gunte ====', this.itemDetail.gunte)
      console.log('sun ====', this.itemDetail.sun)
      console.log('save param', param)

      try {

        this.openLoading('saving')

        if (!param.seq || Number(param.seq) === 0) {
          await insertPlan(param)
        } else {
          await updatePlan(param)
        }

        notify('Saved', 'success', 3000)

        this.showDetail = false

        await this.btnSearch()

      } finally {
        this.endLoading()
      }
      },

      resetActualParam(param) {

        return {
          // 
          wkDate: param.wkDate,
          respCd: param.respCd,
          teamCd: param.teamCd,
          ser: param.ser,
          empNo: param.empNo,
          sun: param.sun,
          seq: param.seq,

          // 
          gunte: param.gunte,

          // clear data
          shipNo: '',
          workAct: '',
          wkPlace: '',
          fr_time: '',
          to_time: '',
          block: '',

          userId: param.userId
        }
        },

    async saveActual() {

      let  param = {
        wkDate: this.movDate.replace(/-/g, ''),
        respCd: this.group,
        teamCd: this.itemDetail.teamJo,
        ser: this.itemDetail.teamGr,

        empNo: this.itemDetail.empNo,
        sun: this.itemDetail.sun,
        seq: this.itemDetail.seq,

        gunte: this.itemDetail.gunte|| '',
        shipNo: this.itemDetail.shipNo|| '',
        workAct: this.itemDetail.workAct|| '',
        wkPlace: this.itemDetail.wkPlace|| '',
        fr_time: this.itemDetail.ftime|| '',
        to_time: this.itemDetail.ttime|| '',
        block: this.itemDetail.block|| '',

        userId: this.$store.state.user.userId
      }

      if (param.gunte && param.gunte.trim() !== '') {
          param = this.resetActualParam(param)
      }

      try {
        this.openLoading('saving')

        await deleteActual(param)
        console.log('ACTUAL SAVE PARAM', param)
        await insertActual(param)

        //
        notify('Saved', 'success', 3000)

        this.showDetail = false

        await this.btnSearch()

        } finally {
          this.endLoading()
        }
      },
      
      async btnDelete(item) {

        this.vToastifyPrompt(
          'Do you want to delete this row?',
          'info',
          async () => {

            if (!this.group?.startsWith('5')) {
              this.itemDetail.teamJo = '00'
              this.itemDetail.teamGr = '0'
            }

            const param = {
              wkDate: this.movDate.replace(/-/g, ''),
              respCd: this.group,

              teamCd: !this.group?.startsWith('5')
                ? '00'
                : item.teamJo,

              ser: !this.group?.startsWith('5')
                ? '0'
                : item.teamGr,

              empNo: item.empNo,

              sun: item.sun,

              seq: item.seq,

              userId: this.$store.state.user.userId
            }

            try {
              this.openLoading('deleting')

              if (this.searchType === 'P') {
                await deletePlan(param)
              } else
              {
                await deleteActual(param)
              }

              notify('Deleted', 'success', 3000)

              await this.btnSearch()

            } finally {
              this.endLoading()
            }
          },
          null,
          true
        )
        },
    async listItemClick(item) {
      this.isNew = false
      this.itemDetail = JSON.parse(JSON.stringify(item))

      //
      if (!this.group?.startsWith('5')) {
        this.itemDetail.teamJo = '00'
        this.itemDetail.teamGr = '0'
      }
      //
      this.listWorkAct = []

      // 
      await this.loadWorkAct()

      this.showDetail = true
    },

    uppercase() {
      this.block = this.block.toUpperCase()
    },      

    btnResetClick() {
      this.isNew = true

      this.oriItem = {}
      this.itemDetail = {}
    }
  }

}
</script>
<style>
.search-panel .v-expansion-panel-content__wrap {
  padding: 16px 24px !important;
}

.result-panel .v-expansion-panel-content__wrap {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.sign-status{
  min-width:120px;
  text-align:center;
  padding:6px 12px;
  border-radius:14px;
  font-size:13px;
  font-weight:600;
  user-select:none;
}

.status-sign0{
  color:#424242;
  background:#eeeeee;
}

.status-sign1{
  color:#b26a00;
  background:#fff3cd;
}

.status-sign2{
  color:#1b5e20;
  background:#d4edda;
}

</style>
